module.exports = __webpack_public_path__ + "static/media/play.23afb619.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/play.svg
// module id = 34
// module chunks = 0